import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import "./OptInPage.css";
import { TextField, FormControlLabel, Checkbox, Button } from "@mui/material";

function OptInPage() {
  const { slug } = useParams();

  const [clientData, setClientData] = useState(null);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [optInAll, setOptInAll] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false); // State to track success page visibility

  useEffect(() => {
    const fetchClientData = async () => {
      if (!slug) return;
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/clients.php?slug=${slug}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch client data");
        }
        const data = await response.json();
        setClientData(data);
      } catch (error) {
        console.error("Error fetching client data:", error);
      }
    };

    fetchClientData();
  }, [slug]);

  const handleSubmit = async (e) => {
    e.preventDefault();


    const optInData = {
      client_id: clientData?.id,
      name: fullName || null,
      email: optInAll ? email : null,
      phone: optInAll ? phone : null,
      opt_in_email: optInAll ? 1 : 0,
      opt_in_sms: optInAll ? 1 : 0,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/optin.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(optInData),
        }
      );

      if (response.ok) {
        setIsSuccess(true); // Hide all content
        setSuccessMessage("You have successfully opted in for updates!");
      } else {
        const result = await response.json();
        setSuccessMessage(
          result.message || "Failed to process your opt-in request."
        );
      }
    } catch (error) {
      console.error("Error submitting opt-in data:", error);
      setSuccessMessage("Received! Thank you for opting in.");
    }
  };

  return (
    <div className="opt-in-page-container">
      {isSuccess ? (
        <div className="success-container">
          {clientData.logo && (
            <img
              src={`${process.env.REACT_APP_BACKEND_URL}/${clientData.logo}`}
              alt={`${clientData.name} Logo`}
              style={{ maxHeight: "400px", marginBottom: "1rem" }}
            />
          )}
          <h1>Thank you for opting in!</h1>
          <p>{successMessage}</p>
        </div>
      ) : (
        <>
          {clientData && (
            <div className="client-header">
              {clientData.logo && (
                <img
                  src={`${process.env.REACT_APP_BACKEND_URL}/${clientData.logo}`}
                  alt={`${clientData.name} Logo`}
                  style={{ maxHeight: "400px", marginBottom: "1rem" }}
                />
              )}
              <h1>Stay Connected with {clientData.name}</h1>
            </div>
          )}

          {!clientData && <h1>Stay Connected</h1>}

          <p>Opt in to receive updates and notifications via email or SMS.</p>
          {successMessage && (
            <p className="success-message">{successMessage}</p>
          )}

          <form onSubmit={handleSubmit} className="opt-in-form">
            <TextField
              label="Name"
              variant="outlined"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              fullWidth
              sx={{
                marginBottom: "1em",
                "& .MuiOutlinedInput-root": {
                  color: "white",
                  "& fieldset": {
                    borderColor: "white",
                  },
                  "&:hover fieldset": {
                    borderColor: "white",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "white",
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "white",
                },
              }}
              InputLabelProps={{ style: { color: "white" } }}
              InputProps={{ style: { color: "white" } }}
            />

            <TextField
              label="Email Address"
              variant="outlined"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              sx={{
                marginBottom: "1em",
                "& .MuiOutlinedInput-root": {
                  color: "white",
                  "& fieldset": {
                    borderColor: "white",
                  },
                  "&:hover fieldset": {
                    borderColor: "white",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "white",
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "white",
                },
              }}
              InputLabelProps={{ style: { color: "white" } }}
              InputProps={{ style: { color: "white" } }}
            />

            <TextField
              label="Phone Number"
              variant="outlined"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              fullWidth
              sx={{
                marginBottom: "1em",
                "& .MuiOutlinedInput-root": {
                  color: "white",
                  "& fieldset": {
                    borderColor: "white",
                  },
                  "&:hover fieldset": {
                    borderColor: "white",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "white",
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "white",
                },
              }}
              InputLabelProps={{ style: { color: "white" } }}
              InputProps={{ style: { color: "white" } }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={optInAll}
                  onChange={(e) => setOptInAll(e.target.checked)}
                  sx={{ color: "white" }}
                />
              }
              label={
                <span style={{ color: "white", margin: 0 }}>I consent to be contacted by or on behalf of{" "}
                  {clientData?.name} via email, SMS, or phone call. My
                  information will not be shared and I can unsubscribe at any
                  time. Messages will not exceed 2–4 per month. Standard
                  messaging and data rates apply. Text STOP to opt out at any
                  time.{" "}
                  <Link
                    to="/terms"
                    style={{ color: "white", textDecoration: "underline" }}
                  >
                    Privacy Policy
                  </Link>
                </span>
              }
              sx={{ alignItems: "flex-start", marginBottom: "1em" }}
            />

            <Button type="submit" variant="contained" color="primary" disabled={!optInAll} sx={{"&.Mui-disabled": {backgroundColor: "#0b4076"}}}>
              Submit
            </Button>
          </form>
        </>
      )}
    </div>
  );
}

export default OptInPage;
